
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';
import { useGlobalState } from '../../store/carOwnerRight';
import dayjs from 'dayjs';
export default defineComponent({
  name: 'RecordDetail',
  setup() {
    const state = useGlobalState();
    const route = useRoute();
    const { awardName, createTime, activityNo, money } = route.query;
    const detail = computed(() => state.value.curRights.find((item) => item.activity.includes(activityNo as string)));
    const configMoney = computed(() => {
      const matchArr = detail.value?.homeInfo.match(/\d+/g);
      if (matchArr?.length) {
        return matchArr[0];
      }
      return '';
    });
    return {
      dayjs,
      awardName,
      createTime,
      money,
      configMoney,
      detail,
    };
  },
});
